export const CREATE_PAYMENT_URL = 
  process.env.REACT_APP_CREATE_PAYMENT_URL || 
  'https://us-central1-asidorsmusic.cloudfunctions.net/createPayment';

export const DOWNLOAD_URL = 
  process.env.REACT_APP_DOWNLOAD_URL || 
  'https://us-central1-asidorsmusic.cloudfunctions.net/downloadPurchasedMusic';

export const GET_PURCHASES_URL = 
  process.env.REACT_APP_GET_PURCHASES_URL || 
  'https://us-central1-asidorsmusic.cloudfunctions.net/getUserPurchases';

// ==========================================
// PAYMENT CONFIGURATION
// ==========================================
export const DEFAULT_PRICE = '12.99';
export const MINIMUM_PRICE = 0.99;
export const MAXIMUM_PRICE = 999.99;

// ==========================================
// PAYMENT STATUS CODES
// ==========================================
export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
};

// ==========================================
// DOWNLOAD CONFIGURATION
// ==========================================
export const DOWNLOAD_CONFIG = {
  TOKEN_EXPIRY_TIME: 24 * 60 * 60 * 1000,
  SINGLE_USE: true,
  TIMEOUT: 300,
};

// ==========================================
// PAYMENT METHOD DETAILS (PADDLE ONLY)
// ==========================================
export const PAYMENT_METHOD_DETAILS = {
  paddle: {
    name: 'Paddle',
    icon: '💳',
    description: 'Credit/Debit Card or PayPal',
    currency: 'USD',
    supportedCurrencies: ['USD'],
    processingFee: 0
  }
};

// ==========================================
// PAYMENT VALIDATION
// ==========================================
export const validatePrice = (price) => {
  const numPrice = parseFloat(price);
  
  if (isNaN(numPrice)) {
    return { valid: false, error: 'Invalid price format' };
  }
  
  if (numPrice < MINIMUM_PRICE) {
    return { valid: false, error: `Minimum price is $${MINIMUM_PRICE}` };
  }
  
  if (numPrice > MAXIMUM_PRICE) {
    return { valid: false, error: `Maximum price is $${MAXIMUM_PRICE}` };
  }
  
  return { valid: true, error: null };
};

// ==========================================
// LOGGING (Development Only)
// ==========================================
if (process.env.NODE_ENV === 'development') {
  console.log('=== Payment Configuration (Paddle) ===');
  console.log('CREATE_PAYMENT_URL:', CREATE_PAYMENT_URL);
  console.log('DOWNLOAD_URL:', DOWNLOAD_URL);
  console.log('GET_PURCHASES_URL:', GET_PURCHASES_URL);
  console.log('===== ===== ===== ===== ===== =====');
}